import { setTheme } from '../styles/theme'

globalThis.apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3333'
globalThis.lang = 'br'
globalThis.storageKey = '@flowexpertrequestportal'
globalThis.setTheme = setTheme

export {}
